<template>
  <transition name="cookie-slide">
    <div v-if="visible" class="cookie-banner">
      <p class="cookie-title">{{ $t('cookie.title') }}</p>
      <p class="cookie-subtitle">{{ $t('cookie.subtitle') }}</p>
      <div class="cookie-actions">
        <button class="cookie-btn" @click="accept">{{ $t('cookie.accept') }}</button>
        <router-link to="/terms" class="cookie-arrow-btn" title="Learn more">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M3 13L13 3M13 3H5M13 3V11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </router-link>
        <button class="cookie-btn" @click="decline">{{ $t('cookie.decline') }}</button>
        <button class="cookie-btn" @click="essential">{{ $t('cookie.essential') }}</button>
      </div>
    </div>
  </transition>
</template>

<script>
const STORAGE_KEY = 'cookie-consent'

export default {
  name: 'CookieConsent',
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    if (!localStorage.getItem(STORAGE_KEY)) {
      this.visible = true
    } else {
      this.applyStoredConsent()
    }
  },
  methods: {
    accept() {
      localStorage.setItem(STORAGE_KEY, 'accept')
      this.updateGtag({
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
      })
      this.visible = false
    },
    decline() {
      localStorage.setItem(STORAGE_KEY, 'decline')
      this.denyAll()
      this.visible = false
    },
    essential() {
      localStorage.setItem(STORAGE_KEY, 'essential')
      this.denyAll()
      this.visible = false
    },
    applyStoredConsent() {
      const val = localStorage.getItem(STORAGE_KEY)
      if (val === 'accept') {
        this.updateGtag({
          analytics_storage: 'granted',
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted'
        })
      } else {
        this.denyAll()
      }
    },
    denyAll() {
      this.updateGtag({
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        ads_data_redaction: 'true'
      })
    },
    updateGtag(settings) {
      if (typeof window.gtag !== 'function') return
      setTimeout(() => window.gtag('consent', 'update', settings), 200)
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 9999;
  width: 400px;
  background: #1CA5BE;
  border-radius: 16px;
  padding: 24px 28px 20px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.18);
}

.cookie-title {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 1.3rem;
  font-weight: 600;
  color: #fff;
  letter-spacing: -0.03em;
  margin: 0 0 6px;
}

.cookie-subtitle {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.55);
  margin: 0 0 20px;
  line-height: 1.4;
}

.cookie-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.cookie-btn {
  font-family: "SF Pro Display", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: rgba(0, 0, 0, 0.7);
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  transition: color 0.2s ease;
}

.cookie-btn:first-child {
  color: #fff;
}

.cookie-btn:hover {
  color: #fff;
}

.cookie-arrow-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #fff;
  color: #1CA5BE;
  text-decoration: none;
  flex-shrink: 0;
  transition: background 0.2s ease, color 0.2s ease;
}

.cookie-arrow-btn:hover {
  background: rgba(255, 255, 255, 0.85);
}

/* Transition */
.cookie-slide-enter-active,
.cookie-slide-leave-active {
  transition: transform 0.35s ease, opacity 0.35s ease;
}

.cookie-slide-enter-from,
.cookie-slide-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

@media (max-width: 480px) {
  .cookie-banner {
    left: 12px;
    right: 12px;
    width: auto;
    bottom: 12px;
  }
}
</style>
